import { render, staticRenderFns } from "./ContainerHeader.vue?vue&type=template&id=ebb4effe&scoped=true"
import script from "./ContainerHeader.vue?vue&type=script&lang=js"
export * from "./ContainerHeader.vue?vue&type=script&lang=js"
import style0 from "./ContainerHeader.css?vue&type=style&index=0&id=ebb4effe&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb4effe",
  null
  
)

export default component.exports